module.exports = __webpack_public_path__ + "img/a12.11e74f80.jpg";